import AccordionItem from '../../UI/AccordionItem';
import AccordionWrapper from '../../UI/AccordionWrapper';
import Pills from '../../UI/Pills';
import classes from './SlotsDetail.module.css';
const SlotsDetail = ({ value, setter, slots = {} }) => {

  const header = Object.keys(slots);
  // headers contain ["afterNoonSlots","eveningSlots","nightSlots"]


  let content = header?.map((head) => (
    <AccordionItem key={head} eventKey={head} header={head}>
      <div className={classes.wrapper}>
        {slots[head]?.map((data) => (
          <>
            <Pills
              clickAreaAll={true}
              selected={value?.timeFrom === data?.timeFrom}
              label={data?.timeFrom}
              onClick={() => {
                if (typeof setter === 'function') setter(data);
              }}
            />
          </>
        ))}
      </div>
    </AccordionItem>
  ));
  return (
    <div className={classes.slotsWrapper}>
      <AccordionWrapper className={classes.accordionItem}>{content}</AccordionWrapper>
    </div>
  );
};

export default SlotsDetail;
